<template>
  <div class="page-wrapper">
    <search-group :multipleLines="true" :inline="true"
                  :span="24" :btnOffset="18" :btnSpan="6"
                  @search="findData" @clear="clearValue">
      <Row :gutter="16">
        <Col span="5">
          <Select placeholder="请选择项目" v-model="searchData.projectFid">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="4">
          <Select placeholder="是否启用" v-model="searchData.openState">
            <Option value="" >请选择</Option>
            <Option v-for="(item,index) in openStateList" :value="item.value" :key="'keyC'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="4">
          <Select placeholder="请选择评价类型" v-model="searchData.evaluateType">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in evaluateTypeList" :value="item.value" :key="'keyB'+index">{{item.text}}
            </Option>
          </Select>
        </Col>
      </Row>
    </search-group>
    <table-list
      title="" :columns="columns" :data="data"
      :loading="loading"
      :total="total"
      :current="current"
      @change-page="changePage"
    ></table-list>
  </div>

</template>

<script>
  import SearchGroup from 'components/SearchGroup/index';
  import TableList from "components/TableList/index";
  import {getProjects} from "../../../api/common";
  import {getConfigListCondition, getConfigList, changeConfigState} from "../../../api/evaluation";


  export default {
    name: "entrance",
    components: {
      SearchGroup,
      TableList
    },
    data() {
      return {
        searched: null,   // just for  changePage
        projectList: [],
        loading: false,
        total: 0,
        current: 1,
        data: [],
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: "项目名称",
            key: "projectName",
            align: "center",
          },
          {
            title: "约看评价",
            key: "appointStatus",
            align: "center",
            render: (h, params) => {
              return h('a', {
                on:{
                  click:()=>{
                    let state=params.row['appointStatus']===1?0:1
                    this.changeConfigState(params.row['appointStatusConfigFid'],state)
                  }
                }
              }, params.row['appointStatus']===1?'停用':(params.row['appointStatus']===0?'启用':''))
            }
          },
          {
            title: "新签评价",
            key: "newSignStatus",
            align: "center",
            render: (h, params) => {
              return h('a', {
                on:{
                  click:()=>{
                    let state=params.row['newSignStatus']===1?0:1
                    this.changeConfigState(params.row['newSignStatusConfigFid'],state)
                  }
                }
              }, params.row['newSignStatus']===1?'停用':(params.row['newSignStatus']===0?'启用':''))
            }
          },
          {
            title: "续约评价",
            key: "renewStatus",
            align: "center",
            render: (h, params) => {
              return h('a', {
                on:{
                  click:()=>{
                    let state=params.row['renewStatus']===1?0:1
                    this.changeConfigState(params.row['renewStatusConfigFid'],state)
                  }
                }
              }, params.row['renewStatus']===1?'停用':(params.row['renewStatus']===0?'启用':''))
            }
          },
          {
            title: "租期评价",
            key: "leaseStatus",
            align: "center",
            render: (h, params) => {
              return h('a', {
                on:{
                  click:()=>{
                    let state=params.row['leaseStatus']===1?0:1
                    this.changeConfigState(params.row['leaseStatusConfigFid'],state)
                  }
                }
              }, params.row['leaseStatus']===1?'停用':(params.row['leaseStatus']===0?'启用':''))
            }
          },
          {
            title: "续约调研",
            key: "renewDyStatus",
            align: "center",
            render: (h, params) => {
              return h('a', {
                on:{
                  click:()=>{
                    let state=params.row['renewDyStatus']===1?0:1
                    this.changeConfigState(params.row['renewDyStatusConfigFid'],state)
                  }
                }
              }, params.row['renewDyStatus']===1?'停用':(params.row['renewDyStatus']===0?'启用':''))
            }
          },
          {
            title: "解约调研",
            key: "surrenderDyStatus",
            align: "center",
            render: (h, params) => {
              return h('a', {
                on:{
                  click:()=>{
                    let state=params.row['surrenderDyStatus']===1?0:1
                    this.changeConfigState(params.row['surrenderDyStatusConfigFid'],state)
                  }
                }
              }, params.row['surrenderDyStatus']===1?'停用':(params.row['surrenderDyStatus']===0?'启用':''))
            }
          },
        ],
        evaluateTypeList: [],
        openStateList: [],
        searchData:{
          page:1,
          limit:10,
          projectFid:'',
          evaluateType:'',
          openState:''
        }
      }
    },
    methods: {
      changeConfigState(id,state) {
        let params = {
          evaluateConfigFid: id,
          openState: state
        }
        changeConfigState(params).then(res => {
          this.getConfigList(this.searched)
        }).catch(error => {})
      },
      getConfigList(data) {
        this.data=[]
        this.total=0

        getConfigList(data).then(res => {
          if(!res.data){
            return
          }
          this.total = res.data.total
          this.data=res.data.rows
          this.searched = Object.assign({}, data)
        }).catch(error => {
        })
      },
      findData() {
        this.current = 1
        this.searchData.page=1

        this.getConfigList(this.searchData)
      },
      clearValue() {
        this.searchData={
          page:1,
          limit:10,
          projectFid:'',
          evaluateType:'',
          openState:''
        }

      },
      changePage(n) {
        this.current = n;
        this.searched.page = n
        this.getConfigList(this.searched)
      }
    },
    created() {
      getProjects().then(res => {
        this.projectList = res.data
      }).catch(error => {
      })
      getConfigListCondition().then(res => {
        if(!res.data){
          return
        }
        this.openStateList = res.data.openState
        this.evaluateTypeList = res.data.evaluateType

      }).catch(error => {
      })
      this.getConfigList(this.searchData)



      // this.getConfigList()
    }
  }
</script>

<style scoped>
  .search-wrapper {
    padding: 0;
  }
</style>
